import { AccountCreation } from '@views/auth/signup/AccountCreation/AccountCreation';
import { CountrySelection } from '@views/auth/signup/CountrySelection/CountrySelection';
import { useSignupPageContext } from '@views/auth/signup/SignupPageContext';

const SignupPageContent = () => {
  const { currentPage } = useSignupPageContext();
  if (currentPage === 'account_creation') {
    return <AccountCreation />;
  }
  if (currentPage === 'country_selection') {
    return <CountrySelection />;
  }
  return null;
};

const SignUpPage = (): JSX.Element => <SignupPageContent />;

SignUpPage.isPublic = true;

export default SignUpPage;
